var label = {exports: {}};

export { label as __module };
